import { lovemoBrand } from '@/mocks/lovemoContent';
import { lovemoScrollToSection } from '@/hooks/useLovemoScrollTo';
import LovemoButton from '@/components/base/LovemoButton';

export default function LovemoCta() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 pb-16 md:px-8 md:pb-24">
        <div className="lovemo-reveal relative isolate overflow-hidden rounded-2xl border border-primary-200/70 bg-gradient-to-br from-primary-100 via-accent-100 to-secondary-100 px-6 py-12 md:px-14 md:py-16">
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute -left-10 -top-10 h-40 w-40 rounded-full bg-primary-200/50 blur-3xl" />
            <div className="absolute -right-8 bottom-0 h-48 w-48 rounded-full bg-accent-200/50 blur-3xl" />
          </div>

          <div className="relative flex flex-col items-center gap-8 md:flex-row md:items-center md:justify-between">
            <div className="max-w-xl text-center md:text-left">
              <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                准备好和Lovemo聊聊天了吗
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
                现在就可以通过Lovemo官网完成官方正版下载，官方提供Lovemo下载教程，把这份温柔的陪伴装进你的手机。
              </p>
              <div className="mt-6 flex flex-wrap justify-center gap-3 md:justify-start">
                <LovemoButton
                  variant="outline"
                  size="md"
                  onClick={() => lovemoScrollToSection('lovemo-download')}
                  className="bg-background-50"
                >
                  <i className="ri-book-open-line text-base" aria-hidden="true" />
                  查看下载教程
                </LovemoButton>
                <LovemoButton
                  variant="ghost"
                  size="md"
                  onClick={() => lovemoScrollToSection('lovemo-faq')}
                >
                  <i className="ri-question-line text-base" aria-hidden="true" />
                  常见问题
                </LovemoButton>
              </div>
            </div>

            <div className="relative flex h-36 w-36 shrink-0 items-center justify-center md:h-52 md:w-52">
              <img
                src={lovemoBrand.mascotAlt}
                alt="Lovemo吉祥物"
                className="animate-lovemo-float h-full w-full object-contain"
                width={208}
                height={208}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}